<!--  -->
<template>
  <div class="content">
    <div class="ban" @click="jump">
      <img src="http://www.hitaledu.com/img/about.png" alt="湖南生易圈教育咨询有限公司" />
    </div>
    <!-- 表单 -->
    <div class="form" id="form">
      <Link text="有什么需求都可联系我们" />
      <div class="card">
        <!-- <div class="text">
          这里是文字内容这里是文字内容这里是文字
          内容这里是文字内容这里是文字内容这里是
          文字内容这里是文字内容这里是文字内容这
          里是文字内容这里是文字内容这里是文字内容
        </div> -->
        <div class="list">
          <div class="li">
            <input
              type="text"
              v-model="form.name"
              class="input"
              placeholder="姓名"
            />
            <input
              type="text"
              v-model="form.email"
              class="input"
              placeholder="电子邮箱"
            />
          </div>
          <div class="li">
            <input
              type="text"
              v-model="form.phone"
              class="input"
              placeholder="手机号"
            />
            <input
              type="text"
              v-model="form.theme"
              class="input"
              placeholder="主题"
            />
          </div>
          <div class="li">
            <input
              v-model="form.note"
              type="textarea"
              :rows="2"
              class="textarea"
              placeholder="我们能为您做些什么?"
            />
          </div>
        </div>
        <!-- 按钮 -->
        <div class="bot" @click="save">提 交</div>
      </div>
    </div>
   <!-- 弹框 -->
   <div class="yes" v-show="yes_show">
     <div class="ff">
            <img src="../../assets/yes.png" alt="湖南生易圈教育咨询有限公司">
            <div class="title">
              提交成功！
            </div>
            <div class="texts">
              我们后续将会有工作人员联系您！
            </div>

     </div>
   </div>
  </div>
</template>

<script>
let marker, map;
import Link from "../../components/all_text.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Link,
  },
  data() {
    //这里存放数据
    return {
        yes_show:false,//
      form: {
        name: "", //姓名
        email: "", //邮箱
        phone: "", //手机号
        theme: "", //主题
        note: "", //备注
      
      },
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    showMap() {
      map = new AMap.Map("container", {
        resizeEnable: true,
        center: [112.98773, 28.188735],
        zoom: 20,
      });
      marker = new AMap.Marker({
        position: [112.98773, 28.188735],
        icon: require("../../assets/add.png"),
      });
      map.add(marker);
      marker.setMap(map);
      //鼠标点击marker弹出自定义的信息窗体
      AMap.event.addListener(marker, "click", function () {
        infoWindow.open(map, marker.getPosition());
      });
      //实例化信息窗体
      var title = "",
        content = [];
      content.push(
        "<div style='font-size:14px;padding:20px 20px 0 20px'>地址：湖南省长沙市芙蓉区芙蓉中路二段111号华菱大厦20楼</div>"
      );
      content.push(
        "<div style='font-size:14px;padding: 0 20px 20px 20px'>邮箱：1939595471@qq</div><div style='font-size:14px;padding: 0 20px 20px 20px'>电话：010-64733333</div>"
      );

      var infoWindow = new AMap.InfoWindow({
        isCustom: true, //使用自定义窗体
        content: this.createInfoWindow(title, content.join("<br/>")),
        offset: new AMap.Pixel(16, -45),
      });
    },
    //关闭信息窗体
    closeInfoWindow() {
      map.clearInfoWindow();
    },
    //构建自定义信息窗体
    createInfoWindow(title, content) {
      var info = document.createElement("div");
      info.className = "custom-info input-card content-window-card";

      //可以通过下面的方式修改自定义窗体的宽高
      //info.style.width = "400px";
      // 定义顶部标题
      var top = document.createElement("div");
      var titleD = document.createElement("div");
      var closeX = document.createElement("img");
      top.className = "info-top";
      top.style.position = "absolute";
      top.style.margin = "-20px 0 0 300px ";
      titleD.innerHTML = title;
      closeX.src = "https://webapi.amap.com/images/close2.gif";
      closeX.onclick = this.closeInfoWindow;

      top.appendChild(titleD);
      top.appendChild(closeX);
      info.appendChild(top);

      // 定义中部内容
      var middle = document.createElement("div");
      middle.className = "info-middle";
      middle.style.backgroundColor = "white";
      middle.innerHTML = content;
      info.appendChild(middle);

      // 定义底部内容
      var bottom = document.createElement("div");
      bottom.className = "info-bottom";
      bottom.style.position = "relative";
      bottom.style.top = "0px";
      bottom.style.margin = "0 0 0 170px ";
      var sharp = document.createElement("img");
      sharp.src = "https://webapi.amap.com/images/sharp.png";
      bottom.appendChild(sharp);
      info.appendChild(bottom);
      return info;
    },
    // 底部
    jump() {
      let jump = document.getElementById("form");
      // 获取需要滚动的距离
      let total = jump.offsetTop;
      console.log(jump.offsetTop);

      // Chrome
      document.body.scrollTop = total;
      // Firefox
      document.documentElement.scrollTop = total;
      // Safari
      window.pageYOffset = total;
    },
   
    // 提交
    save() {
      //  var regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (
        !/^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(
          this.form.email
        )
      ) {
        
        this.$message({
          message: "邮箱格式不正确",
          type: "warning",
        });
        // this.yes_show=true;
       
        return;
      }
      if (!/^[1][3,4,5,7,8][0-9]{9}$/.test(this.form.phone)) {
        this.$message({
          message: "请输入正确电话！",
          type: "warning",
        });
        return;
      }
      this.$http
        .post(
          "http://www.hitaledu.com/admin/message/additional_message",
          this.form
        )
        .then((response) => {
          if (response.data.code == 0) {
            // this.$message({
            //   message: response.data.msg,
            //   type: "success",
            // });
            this.form = {
              name: "", //姓名
              email: "", //邮箱
              phone: "", //手机号
              theme: "", //主题
              note: "", //备注
            };
             this.yes_show=true;
         setTimeout(()=>{
            this.yes_show=false;
         },2000)
          } else {
            this.$message({
              message: response.data.msg,
              type: "error",
            });
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.showMap();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="less">
@screen-sm-min: 414px;

@media (max-width: @screen-sm-min) {
  .text {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #6e6e6e;
    line-height: 31px;
    text-align: center;
    padding: 10px;
  }
  // 表单
  .form {
    padding: 10px 0;
  }
  .input {
    // width: 100%;
    height: 56px;
    background: #f7f7f7;
    border-radius: 3px 3px 3px 3px;
    border: none;
    margin: 10px;
    padding-left: 15px;
  }
  .bot {
    width: 200px;
    height: 40px;
    background: #1472ff;
    border-radius: 30px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    margin-left: 50%;
    transform: translateX(-50%);
  }
}

@screen-lg-min: 1200px;
/* 大屏幕（大桌面显示器，大于等于 1200px） */
@media (min-width: @screen-lg-min) {
  // 公共块的样式
  .text {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #6e6e6e;
    line-height: 31px;
    text-align: center;
    padding: 20px 200px 40px 200px;
  }
  // 表单
  .form {
    padding: 87px 0;
  }
  .input {
    width: 580px;
    height: 56px;
    background: #f7f7f7;
    border-radius: 3px 3px 3px 3px;
    border: none;
    margin: 10px 0;
    padding-left: 15px;
  }
  .bot {
    width: 300px;
    height: 60px;
    background: #1472ff;
    border-radius: 30px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 60px;
    text-align: center;
    margin-left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
  }
}
// ban
.ban {
  img {
    width: 100%;
  }
}

.list {
  padding: 40px 0;
  .li {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #7d7e81;
    margin: 10px 0;

    .input {
      width: 580px;
      height: 56px;
      background: #f7f7f7;
      border-radius: 3px 3px 3px 3px;
      border: none;
      margin: 10px 0;
      padding-left: 15px;
      font-size: 16px;
    }
    input:focus {
      outline: none;
      border-color: #9ecaed;
      box-shadow: 0 0 10px #9ecaed;
    }
    .textarea {
      width: 99.9%;
      padding-left: 15px;
      height: 106px;
      background: #f7f7f7;
      border-radius: 3px 3px 3px 3px;
      border: none;
      font-size: 16px;
    }
  }
}

//   地图
.map {
  width: 100%;
  height: 487px;

  #container {
    width: 100%;
    height: 487px;
    // filter: grayscale(100%);
  }
}
.content-window-card {
  position: relative;
  box-shadow: none;
  bottom: 0;
  left: 0;
  width: auto;
  padding: 0;
}

.content-window-card p {
  height: 2rem;
}

.custom-info {
  border: solid 1px silver;
}

.info-top {
  position: relative;
  background: #ffff !important;
  border-bottom: 1px solid #ccc;
  border-radius: 5px 5px 0 0;
  margin-left: 20px;
}

div.info-top div {
  background: #fff !important;
  display: inline-block;
  color: #333333;
  font-size: 14px;
  font-weight: bold;
  line-height: 31px;
  padding: 0 10px;
}

div.info-top img {
  position: absolute;
  top: 30px;
  right: 10px;
  transition-duration: 0.25s;
}

div.info-top img:hover {
  box-shadow: 0px 0px 5px #000;
}

div.info-middle {
  font-size: 12px;
  padding: 10px 6px;
  line-height: 20px;
}

div.info-bottom {
  height: 0px;
  width: 100%;
  clear: both;
  text-align: center;
}

div.info-bottom img {
  position: relative;
  z-index: 104;
}

span {
  margin-left: 5px;
  font-size: 11px;
}

.info-middle img {
  float: left;
  margin-right: 6px;
}
.yes{
  position: fixed;
  top: 0;
  z-index: 999;
  width: 100%;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  img{
    width: 70px;
    // height: 321px;
   margin-left: 50%;
   transform: translateX(-50%);
   margin-top: 20px;

    
   
  }
  .ff{
    background: #fff;
    width: 200px;
    height: 200px;
     left: 50%;
    margin-left: -75px;
    // transform: translateX(-270px);
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      border-radius: 10px;
      .title{
        text-align: center;
        padding:5px;
      }
      .texts{
        padding: 10px 30px;
        text-align: center;
        color: #9b9898;
      }
  }
}
</style>